var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Nodata',{staticClass:"auth-no-data",attrs:{"size":200,"type":2}},[_vm._v(_vm._s(_vm.errorMsg))])}
var staticRenderFns = []

export { render, staticRenderFns }